import { render, staticRenderFns } from "./CompliancePublishtable.vue?vue&type=template&id=25ec32b6&scoped=true&"
import script from "./CompliancePublishtable.vue?vue&type=script&lang=js&"
export * from "./CompliancePublishtable.vue?vue&type=script&lang=js&"
import style0 from "./CompliancePublishtable.vue?vue&type=style&index=0&id=25ec32b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ec32b6",
  null
  
)

export default component.exports